// Dev Dashboard → Changelog tab. Renders the curated product changelog (newest first).
import { CHANGELOG, type ChangelogCategory } from '@lib/data/changelog';

const CAT_STYLE: Record<ChangelogCategory, { label: string; cls: string; icon: string }> = {
  feature:  { label: 'Feature',  cls: 'bg-ochre-100 text-ochre-800', icon: 'auto_awesome' },
  fix:      { label: 'Fix',      cls: 'bg-blue-100 text-blue-800',   icon: 'build' },
  security: { label: 'Security', cls: 'bg-red-100 text-red-800',     icon: 'security' },
  infra:    { label: 'Infra',    cls: 'bg-gray-200 text-gray-700',   icon: 'dns' },
  ux:       { label: 'UX',       cls: 'bg-purple-100 text-purple-800', icon: 'palette' },
};

export function ChangelogTab() {
  return (
    <div className="max-w-3xl">
      <div className="mb-6">
        <h2 className="text-lg font-semibold text-gray-900">Changelog</h2>
        <p className="text-sm text-gray-500">Notable changes, backdated to early offline development.</p>
      </div>

      <div className="relative border-l-2 border-gray-200 ml-2 space-y-8">
        {CHANGELOG.map((entry, i) => {
          const cat = CAT_STYLE[entry.category];
          return (
            <div key={i} className="relative pl-6">
              <span className="absolute -left-[9px] top-1.5 w-4 h-4 rounded-full bg-white border-2 border-ochre-500" />
              <div className="flex items-center gap-2 flex-wrap mb-1">
                <span className="text-sm font-mono text-gray-500">{entry.date}</span>
                <span className={`inline-flex items-center gap-1 text-xs font-medium px-2 py-0.5 rounded-full ${cat.cls}`}>
                  <span className="material-symbols-outlined text-xs">{cat.icon}</span>
                  {cat.label}
                </span>
              </div>
              <h3 className="text-sm font-semibold text-gray-800 mb-2">{entry.title}</h3>
              <ul className="space-y-1">
                {entry.items.map((it, j) => (
                  <li key={j} className="text-sm text-gray-600 flex gap-2">
                    <span className="text-ochre-400 mt-1">•</span>
                    <span>{it}</span>
                  </li>
                ))}
              </ul>
            </div>
          );
        })}
      </div>
    </div>
  );
}
